export const transactionModalStyles = {
  infoAlert: {
    mt: 1,
  },
  errorAlert: {
    mt: 1,
  },
  emptyText: {
    py: 2,
  },
  selectionInfo: {
    mt: 1,
    mb: 1,
  },
  grid: {
    mt: 1,
    height: 520,
  },
  actionButtonsContainer: {
    display: "flex",
    gap: 1,
    alignItems: "center",
    width: "100%",
  },
  selectButton: {
    minWidth: 92,
  },
  deselectButton: {
    minWidth: 92,
  },
};
